import React from "react"

export interface ArticleCategoryLabelProps {
  category: Queries.ArticleCategoryFieldsFragment
  active?: boolean
  pointer?: boolean
}

const ArticleCategoryLabel = ({
  category,
  active = true,
  pointer = true,
}: ArticleCategoryLabelProps) => {
  if (!category) {
    return null
  }

  return (
    <label
      className={`c-article-category-label u-relative ${
        !pointer ? "-no-pointer" : ""
      }`}
      style={{
        color: active && category?.label?.hex ? category.label.hex : "#C0C0C0",
        borderColor:
          active && category?.label?.hex ? category.label.hex : "#C0C0C0",
      }}
    >
      {category.name}
    </label>
  )
}

export default ArticleCategoryLabel
